module.exports = __webpack_public_path__ + "static/img/xs_img_money.612b4c80.png";